import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { SaveAnalysisDrawer } from '../SaveAnalysis/SaveAnalysisDrawer';
import ScheduleAnalysisDrawer from '../ScheduleSavedAnalysis/ScheduleAnalysisDrawer';
import { useNexaStore } from '../NexaStore';
import { useHasEvents } from '../hooks/useHasEvents';

export const SaveAnalysisButton: React.FC = () => {
  const [openModal, setOpenModal] = useState(false);
  const [scheduleItem, setScheduleItem] = useState<{ id: number; query: string } | null>(null);
  const id = useNexaStore((state) => state.id);
  const { hasEvents, isShareId } = useHasEvents();

  // Only show button if there's a session with events AND not a share
  if (!hasEvents || isShareId) {
    return null;
  }

  return (
    <>
      <Tooltip title="Save Analysis">
        <Button icon={<SaveOutlined />} onClick={() => setOpenModal(true)} />
      </Tooltip>
      <SaveAnalysisDrawer
        open={openModal}
        onClose={() => setOpenModal(false)}
        sessionId={id!}
        onSaveAndSchedule={setScheduleItem}
      />
      <ScheduleAnalysisDrawer
        open={!!scheduleItem}
        onClose={() => setScheduleItem(null)}
        analysisItem={scheduleItem}
        mode="create"
      />
    </>
  );
};
